import React from "react";

const Hero = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image Overlay */}
      <div className="absolute inset-0">
        <div className="w-full h-full bg-gradient-to-br from-gray-900 via-black to-gray-800"></div>
        <div className="absolute inset-0 opacity-10">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `
                linear-gradient(45deg, transparent 25%, rgba(255,255,255,0.1) 25%, rgba(255,255,255,0.1) 50%, transparent 50%, transparent 75%, rgba(255,255,255,0.1) 75%),
                linear-gradient(-45deg, transparent 25%, rgba(255,255,255,0.05) 25%, rgba(255,255,255,0.05) 50%, transparent 50%, transparent 75%, rgba(255,255,255,0.05) 75%)
              `,
              backgroundSize: "60px 60px",
            }}
          ></div>
        </div>
      </div>

      {/* Background Image */}
      <div className="absolute inset-0">
        <div
          className="w-full h-full opacity-70 grayscale"
          style={{
            backgroundImage: `url('https://res.cloudinary.com/dhdyo9wwq/image/upload/v1750189097/black-man-black-suit-standing-cafe_mcfe8a.png')`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <div className="w-full h-full bg-gradient-to-l from-transparent via-black/40 to-black/80"></div>
        </div>
      </div>

      {/* Abstract geometric overlay */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-1/4 w-64 sm:w-80 lg:w-96 h-64 sm:h-80 lg:h-96 border border-white transform rotate-45 opacity-40"></div>
        <div className="absolute bottom-1/4 right-1/4 w-48 sm:w-56 lg:w-64 h-48 sm:h-56 lg:h-64 border border-white transform -rotate-12 opacity-30"></div>
        <div className="absolute top-1/2 right-1/3 w-24 sm:w-28 lg:w-32 h-24 sm:h-28 lg:h-32 bg-white transform rotate-45 opacity-20"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center min-h-screen py-16 lg:py-20">
        {/* Left content */}
        <div className="space-y-8">
          <div>
            <p className="text-[10px] sm:text-xs md:text-[11px] tracking-[0.3em] uppercase text-gray-300 mb-6">
              Professional Development Programs
            </p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-thin tracking-tight leading-none mb-4 text-white">
              MASTER
            </h1>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-thin tracking-tight leading-none mb-6 text-transparent bg-clip-text bg-gradient-to-r from-gray-300 to-white">
              AI SKILLS
            </h1>
            <div className="w-20 sm:w-24 h-px bg-gray-400 mb-6"></div>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-thin tracking-wide text-gray-200 mb-6">
              Transform Your <em className="text-white">Career</em>
            </h2>
          </div>
          <p className="text-sm sm:text-base md:text-lg leading-relaxed tracking-wide text-gray-100 max-w-2xl">
            Practical AI training and resources designed to empower you with the skills you need to boost productivity,
            automate tasks and accelerate your career.
          </p>
        </div>

        {/* Right stats card */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-black/20 to-transparent pointer-events-none"></div>
          <div className="bg-white p-6 sm:p-8 lg:p-10 xl:p-12 shadow-2xl relative">
            <div className="space-y-8">
              <div className="text-center">
                <div className="w-2 h-2 bg-black rounded-full mx-auto mb-4"></div>
                <h3 className="text-xl sm:text-2xl font-thin tracking-wide text-black mb-2">
                  Join 10,000+ Professionals
                </h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  Already transforming their careers with AI
                </p>
              </div>
              <div className="grid grid-cols-3 gap-4 sm:gap-6 text-center">
                <div>
                  <div className="text-2xl sm:text-3xl font-thin text-black mb-1">85%</div>
                  <div className="text-[11px] sm:text-xs text-gray-600 tracking-wide">
                    Productivity Increase
                  </div>
                </div>
                <div>
                  <div className="text-2xl sm:text-3xl font-thin text-black mb-1">40h</div>
                  <div className="text-[11px] sm:text-xs text-gray-600 tracking-wide">
                    Time Saved Monthly
                  </div>
                </div>
                <div>
                  <div className="text-2xl sm:text-3xl font-thin text-black mb-1">92%</div>
                  <div className="text-[11px] sm:text-xs text-gray-600 tracking-wide">
                    Career Advancement
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
